// theme.js
import { createTheme, alpha } from '@mui/material/styles';

export const CONTROL_H = 40;

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#bf8ee2e0',
      light: '#e2b7ffea', 
      dark: '#a079b9c0',
    },
    secondary: {
      main: '#f50057',
      light: '#ff5983',
      dark: '#c51162',
    },
    success: {
      main: '#09cccc9a',
      light: '#25efef99', 
      dark: '#18afafaf',
    },
    background: {
      default: 'linear-gradient(135deg, #0a0a23 0%, #1a1a2e 25%, #16213e 50%, #0f3460 75%, #533483 100%)',
      paper: 'linear-gradient(145deg, rgba(26, 26, 46, 0.9) 0%, rgba(22, 33, 62, 0.8) 100%)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorTransparent: {
          backgroundColor: alpha('#000000', 0.3),
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // backgroundColor: alpha('#1a1a1a', 0.8),
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255,255,255,0.05)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // backgroundColor: alpha('#1a1a1a', 0.9),
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255,255,255,0.05)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          '&.Mui-selected': {
            fontWeight: 600,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: '3px 3px 0 0',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
        contained: {
          boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.24)',
          '&:hover': {
            boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.32)',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: alpha('#1a1a1a', 0.95),
          backdropFilter: 'blur(12px)',
          borderLeft: '1px solid rgba(255,255,255,0.08)',
        },
      },
    },
  },
});

export default theme;
